import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { AuthApi } from '../../shared/nestjs/gd-only/services/auth.api';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { SunfishApi } from '../../shared/sdk/services';

@Injectable()
export class ChangePasswordBloc {

    constructor(
        private nestApiProvider: NestApiProvider,
        private authApi: AuthApi,
        private sunfishApi: SunfishApi,
    ) {

    }

    getSettingManagementPassword(companyCode: string = null): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    return this.authApi.passwordSetting(companyCode)
                        .pipe(
                            map(param => param.data)
                        )
                } else {
                    return this.sunfishApi.getSettingManagementPassword()
                }
            })
    }

    changePassword(password: any): Observable<any> {
        return this.authApi.changePassword(password)
    }

    lifeSpanPassword(): Observable<boolean> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    return this.authApi.lifeSpanPassword()
                        .pipe(
                            map(param => param.data)
                        )
                } else {
                    return this.sunfishApi.getLifeSpanPassword()
                }
            })
    }

}



// WEBPACK FOOTER //
// ./src/bloc/settings/change-password.bloc.ts